import * as actions from "../actions/"

import {toast} from "react-toastify"

const defaultState = {
  fetching: false,
  error: null,
  recentVerifications: [],
  recentDeposits: []
}

export default function reducer(state = defaultState, action) {

  switch (action.type) {
    case actions.FETCH_RECENT.PENDING: {
      return {...defaultState, fetching: true, recentVerifications: [], recentDeposits: []}
    }
    case actions.FETCH_RECENT.ERROR: {
      toast.error(action.payload.response.data.mess || action.payload.error.message);
      return {...state, fetching: false, error: action.payload}
    }
    case actions.FETCH_RECENT.SUCCESS: {
      return {
        ...state,
        fetching: false,
        recentVerifications: action.payload[0],
        recentDeposits: action.payload[1],
      }
    }
  }
  return state
}


// WEBPACK FOOTER //
// ./src/reducers/dashboardReducer.js